import Sentry from '/sentry' //should be first!
import {start as startSync} from '/sync-time'
import {create as createLocales} from '/app-locale'
import {create as createRouter} from '/router-service'
import {Client, setClient} from '/client'
import {server, version} from '/env'

import {onReactionError} from 'mobx'
import {setGlobalConfig, ModelAutoTypeCheckingMode} from 'mobx-keystone'

onReactionError(e => Sentry.captureException(e))
setGlobalConfig({modelAutoTypeChecking: ModelAutoTypeCheckingMode.AlwaysOn})

if (('documentMode' in document || /Edge/.test(navigator.userAgent)) && document.documentElement)
    document.documentElement.dataset['ie'] = '1'

const locales = createLocales()

const headers: Record<string, string> = {locale: locales.current}
if (version)
    headers.version = version

const client = setClient(new Client(server, headers))

startSync(client)
createRouter()

void locales.loadCurrent()
    .then(() => import('/app'))
    .then(r => r.start())
